import React, { useEffect, useRef } from "react";
import * as THREE from 'three';
import gsap from "gsap";

import { sections } from "../../../../common/config";
import useScrollStore from "../../../../common/store/useScrollStore";

const getThreshold = () => sections.height.landing / 100 * window.innerHeight;

const target = new THREE.Vector3(0, -20, 0);

const useConvergeAnimation = (props: {
  ref: React.RefObject<THREE.Group>,
  origin: React.RefObject<THREE.Vector3>
}[]) => {
  const threshold = useRef(getThreshold());

  useEffect(() => useScrollStore.subscribe(state => {
    if (-state.position <= threshold.current) {
      props.forEach(({ ref, origin }) => {
        if (ref.current && origin.current) {
          const distX = target.x - ref.current.position.x;
          const distY = target.y - ref.current.position.y;
          const distZ = target.z - ref.current.position.z;

          const ratio = -state.position / window.innerHeight;

          gsap.to(ref.current!.position, {
            duration: 0,
            x: origin.current.x + (ratio * distX),
            y: origin.current.y + (ratio * distY),
            z: origin.current.z + (ratio * distZ)
          });
        }
      })
    }
  }), [props.length]);

  useEffect(() => {
    const handleResize = () => {
      threshold.current = getThreshold();
    }

    window.addEventListener("resize", handleResize);
    return () => { window.removeEventListener("resize", handleResize) }
  }, []);
}

export default useConvergeAnimation;